import React from 'react';
import { Helmet } from 'react-helmet-async';
import WhatsAppCTA from '../components/WhatsAppCTA';

const PaintCorrection = () => {
  return (
    <div className="min-h-screen bg-black py-16 px-4">
      <Helmet>
        <title>Paint Correction Tralee | Swirl & Scratch Removal | Kingdom Auto Detailing</title>
        <meta name="description" content="Professional paint correction near Tralee. Remove swirl marks, scratches, oxidation and water spots. Restore your car's showroom finish. €51/hour in Co Kerry." />
        <meta name="keywords" content="paint correction Tralee, swirl mark removal, scratch removal car, oxidation removal Ireland, car polish Kerry, paint restoration Kerry" />
        <link rel="canonical" href="https://kingdomautodetailing.ie/paint-correction" />
      </Helmet>

      <div className="max-w-6xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 text-center">
          Paint Correction
        </h1>
        <p className="text-xl text-gray-400 text-center mb-12 max-w-3xl mx-auto">
          Restore your vehicle's paint to showroom condition
        </p>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-3xl p-8 hover:scale-105 transition-transform duration-300">
            <h2 className="text-3xl font-bold text-white mb-6">What is Paint Correction?</h2>
            <p className="text-blue-100 leading-relaxed mb-4">
              Paint correction is a meticulous process that removes surface imperfections from your vehicle's paintwork. 
              This includes swirl marks, light scratches, water spots, and oxidation that can dull your car's appearance.
            </p>
            <p className="text-blue-100 leading-relaxed">
              Using professional-grade compounds and polishes, we carefully restore clarity and depth to your paint, 
              bringing back that showroom shine.
            </p>
          </div>

          <div className="bg-zinc-900 rounded-3xl p-8">
            <h2 className="text-3xl font-bold text-white mb-6">Our Process</h2>
            <ul className="space-y-4">
              {[
                { title: 'Inspection', desc: 'Thorough assessment of paint condition' },
                { title: 'Cleaning', desc: 'Deep wash and decontamination' },
                { title: 'Correction', desc: 'Multi-stage buffing and polishing' },
                { title: 'Protection', desc: 'Application of protective sealant or coating' }
              ].map((step, idx) => (
                <li key={idx} className="flex items-start space-x-3">
                  <span className="text-lime-500 font-bold text-xl">{idx + 1}.</span>
                  <div>
                    <h3 className="text-white font-semibold">{step.title}</h3>
                    <p className="text-gray-400 text-sm">{step.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {[
            { title: 'Swirl Mark Removal', desc: 'Eliminate circular scratches from improper washing' },
            { title: 'Scratch Removal', desc: 'Remove light to moderate surface scratches' },
            { title: 'Oxidation Removal', desc: 'Restore faded and oxidized paint' },
            { title: 'Water Spot Removal', desc: 'Remove mineral deposits and etching' },
            { title: 'Clarity Restoration', desc: 'Bring back original paint depth and reflection' },
            { title: 'Gloss Enhancement', desc: 'Maximize shine and gloss levels' }
          ].map((benefit, idx) => (
            <div
              key={idx}
              className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl p-6 hover:scale-105 transition-transform duration-300"
            >
              <h3 className="text-xl font-bold text-white mb-2">{benefit.title}</h3>
              <p className="text-blue-100 text-sm">{benefit.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-zinc-900 rounded-3xl p-8 md:p-12 text-center">
          <h2 className="text-3xl font-bold text-white mb-6">Pricing</h2>
          <p className="text-4xl font-bold text-amber-500 mb-4">€51.00 per hour</p>
          <p className="text-gray-300 max-w-2xl mx-auto">
            Each vehicle will be inspected prior and it will be determined if 1 stage of paint correction is enough. 
            If additional stages are needed, a detailed quote will be provided.
          </p>
        </div>
      </div>

      {/* WhatsApp CTA */}
      <WhatsAppCTA />
    </div>
  );
};

export default PaintCorrection;